import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import PageHeader from "../../Utility/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import { FetchDriverApprovedBankSlip, FetchDriverNoWaitingDataList } from "../../redux/vehicleRegistration/FetchDriversData";
import LoadingAnimation from "../../shared/LoadingAnimation";
import NoContentsFound from "../../shared/NoContentsFound";
import CarTable4 from "./CarTable4";
// import { sendSMS } from "./SendSMS";
// import CarTable3 from "./CarTable3";

export default function BankSlipApproved() {
  // sendSMS();
  const { t } = useTranslation("translation");
  const data = useSelector((state) => state.vehicle.data);
  const CarsData = useSelector((state) => state.vehicle);
  const loading = useSelector((state) => state.vehicle.loading);
  // const progress = useSelector((state) => state.vehicle.progress);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.authentication.token);

  useEffect(() => {
    // dispatch(FetchDriverNoWaitingDataList(token));
    dispatch(FetchDriverApprovedBankSlip(token));
  }, []);
  return (
    <div>
      <div className="mt-2">
        <PageHeader title={t("vehicle_details_form.carDetailsRegForm")} />
      </div>
      {loading ? (
        <LoadingAnimation />
      ) : data && data.length>0? (
        <CarTable4 carsData={CarsData} recordType={t("vehicle_details_form.approvedBankSlipVehicleList")} />
      ) : (
        <NoContentsFound message={t("general_key_words.dataNotFound")} />
      )}
    </div>
  );
}
